/** Minimal i18n `t` shape used by this helper (avoids coupling tests to TFunction). */
export type TutorReviewTranslateFn = (key: string, defaultValue: string) => string;

type AxiosLikeError = {
  response?: {
    data?: {
      message?: string;
      error?: string;
    };
  };
};

function readServerMessage(error: unknown): string {
  const data = (error as AxiosLikeError)?.response?.data;
  return data?.message || data?.error || '';
}

export function getTutorReviewErrorMessage(error: unknown, t: TutorReviewTranslateFn): string {
  const message = readServerMessage(error);
  const lower = message.toLowerCase();

  if (lower.includes('review already exists')) {
    return t('review.alreadyReviewedTutor', 'You have already reviewed this tutor.');
  }
  if (lower.includes('booking must be confirmed')) {
    return t('review.tutorBookingNotEligible', 'Only confirmed tutor sessions can be reviewed.');
  }
  if (lower.includes('booking does not belong to user')) {
    return t('review.tutorBookingNotOwned', 'This session does not belong to your account.');
  }
  if (lower.includes('booking does not belong to tutor')) {
    return t('review.tutorBookingMismatch', 'This session does not match the selected tutor.');
  }
  if (lower.includes('tutor booking not found') || lower.includes('booking not found')) {
    return t('review.tutorBookingNotFound', 'Session not found.');
  }
  if (lower.includes('tutor not found')) {
    return t('review.tutorNotFound', 'Tutor not found.');
  }
  if (lower.includes('rating must be between 1 and 5')) {
    return t('review.ratingRequired', 'Please select a rating between 1 and 5.');
  }

  return message || t('review.createError', 'Failed to create review. Please try again.');
}
